                                                            <!DOCTYPE html>
@if (selectedProductData$ | async; as selectedProductData) {
<ion-content class="join-content" (click)="touch()">
  @if (loader) {
  <div id="productScroll">
    <ion-fab vertical="top" horizontal="start" slot="fixed"> </ion-fab>
    <div class="product-container">
      <div class="ship-image">
        <!--Image Container-->
        <div class="ship-position">
          <img class="mega-million" [src]="selectedProductData?.lottery_image" alt="image" />
          <img class="ship-image-store" [src]="selectedProductData?.header_image" alt="image" />
          <div class="ship-jackpot">
            <img (click)="goBack()" class="close-fab" src="assets/images/back-shape.png" alt="back-img" />
            <div class="ship-jackpot-name">
              {{ getProductName(selectedProductData) }}
              <ion-icon (click)="showProductInfo()" name="information-circle-outline" class="info-tooltip"></ion-icon>
            </div>
            @if (showFlashSale) {
            <div class="flash-container">
              <div class="flash-sale">
                <p class="flash-title">{{ selectedProductData?.content?.[lang]?.flash_sale }}</p>
                <div class="flash-timer" [ngStyle]="{ width: flashSaleWidth$ | async }">
                  <p>
                    <app-count-down-timer class="custom-promo-timer-text"
                      end="{{ flashSaleVoucherData.expiry_date?.seconds }}"
                      sec="{{ flashSaleVoucherData.expiry_date?.nanoseconds }}" type="seconds">
                    </app-count-down-timer>
                  </p>
                </div>
                <img [src]="selectedProductData?.flash_sale_icon" alt="flash_icon" />
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      <div class="draw-details-container">
        <div class="common-margin draw-details">
          <div class="euro-amt-margin" style="width: 85%">
            <h1 class="jackpot-amount euro-amt bold">
              @if (selectedProductData?.lottery?.featured) {
              <span class="fire-icon-size">🔥</span>
              }
              {{ selectedProductData?.jackpot_value }}
            </h1>
          </div>
          <div class="ng-credit" style="width: 30%">
            <h1 class="credit-toggle-text">{{ selectedProductData?.content?.[lang]?.use_credit }}</h1>
          </div>
        </div>
        <div class="jackpot-amount-details">
          <div class="draw-time-text timer-icon">
            <img src="https://app.lottosocial.com/assets/icon/timer.webp" class="Icon-position" />
            <app-count-down-timer class="remaining-time" (remainingTime)="getRemainingTime($event)"
              end="{{ selectedProductData?.expiry_date?.seconds }}" type="seconds"></app-count-down-timer>
          </div>
          <div class="common-margin toggle-btn toggle-btn-margin">
            <ion-toggle color="secondary" [checked]="creditToggle" (ionChange)="toggleCredit($event.detail)" mode="ios">
            </ion-toggle>
            @if (!creditToggle) {
            <div>
              @if (show$ | async) {
              <div class="tooltip-wrapper">
                @if (productToolTip$ | async; as tooltip) {
                <div class="tooltip-icon">
                  <span class="tooltip-ic">{{ tooltip?.data?.icon }}</span>
                </div>
                <div class="tooltip-content">
                  <h3 class="tooltip-title">
                    {{
                    tooltip?.data?._title && tooltip?.data?._title[lang]
                    ? tooltip?.data?._title[lang]
                    : tooltip?.title
                    }}
                  </h3>
                  <p class="tooltip-desc" [innerHtml]="
                                tooltip && tooltip?.data?._description
                                  ? tooltip?.data?._description[lang]
                                  : tooltip?.description
                              "></p>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>
      @if (creditValueTogg && creditInsufficient) {
      <div class="err-credit-wrap">
        @if (accountBalance$ | async; as accountBalance) {
        <span class="err-bal">
          <!-- £{{ accountBalance?.credit ? accountBalance.credit : 0 }} -->
          {{ currencySymbol }}
          {{ (accountBalance?.preferred_currency?.credit ?? accountBalance?.credit ?? 0) | displayCurrency }}
          {{ selectedProductData?.content?.[lang]?.credit_available }}
        </span>
        <div class="insufficient-wrap">
          <img class="rectangle-arrow" src="./../../../../assets/images/rectangle-uparrow.svg" alt="rectangle-arrow" />
          <p class="insufficient-credit">
            {{ "store-product.credit_insufficient" | translate }}
          </p>
          <span class="top-up" (click)="callTopup()">{{ selectedProductData?.content?.[lang]?.top_up }}</span>
        </div>
        }
      </div>
      }
      <div class="which-wrapper">
        <ion-row class="which-wrapper-content">
          <ion-col class="which-draw-qn" size="5">
            <p class="common-margin jackpot-options-text Whichdraws-margin">
              {{ selectedProductData?.content?.[lang]?.which_draws }}
            </p>
          </ion-col>
          @if (creditValueTogg && !creditInsufficient && !creditRefreshStatus) {
          <ion-col class="credit-balance-wrap" size="7">
            @if (accountBalance$ | async; as accountBalance) {
            <div class="credit-bal">
              <span>{{ currencySymbol }}{{ accountBalance?.preferred_currency?.credit ?? accountBalance?.credit }}
              </span>
              {{ selectedProductData?.content?.[lang]?.credit_available }}
            </div>
            }
          </ion-col>
          }
        </ion-row>
        <div class="drawDay-wrapper">
          @for (day of selectedProductData?.draw_days; track day; let index = $index) {
          <div [ngClass]="day.isSelected ? 'selected-drawDay' : 'unselected-drawDay'"
            (click)="selectDrawday(day, selectedProductData?.draw_days, index)">
            <div class="drawDayFloat">
              <span> {{ "dynamic_value." + (day.draw_day | day) | translate }}</span>
            </div>
            <div class="checkMarkFloat">
              @if (day.isSelected) {
              <img class="check-ic" src="../../../../assets/images/color@2x.png" />
              }
            </div>
          </div>
          }
        </div>
      </div>
      <div class="lines-margin">
        <p class="common-margin jackpot-options-text how-many">{{ selectedProductData?.content?.[lang]?.lines }}</p>
        <div>
          <div class="hand-animation">
            <app-product-animation></app-product-animation>
          </div>
          <div>
            <ion-img src="../../../assets/icon/down-arrow.svg" class="pointer-img"></ion-img>
            @let numbers = creditValueTogg ? selectedProductData?.lines_range?.credit : selectedProductData?.lines_range?.cash;

            <swiper
              [config]="config"
              #numberSlider
              #productNumberSlider
              (slideChangeTransitionStart)="isSlideChanged()"
              (resize)="productNumberSlider.update()"
              class="custom-number-slide"
            >
              @for (number of numbers; track number) { 
                @if (shouldRenderNumber(number)) {
                  <ng-template swiperSlide>
                    <h1
                      class="slidenumber-margin default-slider"
                      [class.true]="irishProduct && number % 2 === 0"
                      [ngClass]="getNumberClasses(number)"
                    >
                      {{ number }}
                    </h1>
                  </ng-template>
                } 
              }
            </swiper>
            <ion-img src="../../../assets/icon/up-arrow.svg" class="pointer-img"></ion-img>
          </div>
        </div>
      </div>
      <div class="how-week">
        <p class="common-margin jackpot-options-text how-week-text"
          [ngClass]="useCredit$.value ? 'jackpot-how-manyline-colour' : ''">
          {{ selectedProductData?.content?.[lang]?.weeks }}
        </p>
        @if (!creditValueTogg) {
        <ion-segment mode="md" [value]="selectedDiscountType()" (ionChange)="creditDiscountChanged($event)">
          <ion-segment-button value="onlyOnce" class="btn-until-stopped">
            <ion-label class="segment">
              {{ selectedProductData?.content?.[lang]?.only_once }}
              <span class="onlyOnceCheckMarkFloat">
                @if (isOnlyOneWeek) {
                <img class="check-ic" src="../../../../assets/images/color@2x.png" />
                }
              </span>
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="untilStopped" class="btn-once">
            <ion-label class="segment">
              {{ selectedProductData?.content?.[lang]?.until_I_stop }}
              <span class="onlyOnceCheckMarkFloat">
                @if (!isOnlyOneWeek) {
                <img class="check-ic" src="../../../../assets/images/color@2x.png" />
                }
              </span>
            </ion-label>
          </ion-segment-button>
        </ion-segment>
        }
        @if (creditValueTogg) {
        <div class="radio-toolbar draws-day">
          <p class="labelview">
            {{ selectedProductData?.content?.[lang]?.only_once }}
            <span class="onlyOnceCheckMarkFloat1">
              <img class="check-ic" src="../../../../assets/images/color@2x.png" />
            </span>
          </p>
        </div>
        }
      </div>
      <div class="total-margin joinbtn">
        <div class="btn-section">
          <!--Buttons Section-->
          @if (selectedProductOffers$ | async; as selectedProductOffers) {
          <div class="join-btn button-enabled">
            <div class="total">
              <span class="total-text"> {{ selectedProductData?.content?.[lang]?.total }}</span>
              <span class="num-text"> {{ currencySymbol }}</span>
              <span class="num-text">
                {{((selectedProductOffers?.int_price?.[preferredCurrency]) ?
                (selectedProductOffers?.int_price?.[preferredCurrency]) : (selectedProductOffers?.price)) | displayCurrency}}
              </span>
              <span class="total-text black-text">
                {{
                creditValueTogg
                ? selectedProductData?.content?.[lang]?.credit
                : selectedProductData?.content?.[lang]?.cash
                }}</span>
              @if (!isOnlyOneWeek && discountPercentage) {
              <span class="total-text1">
                ({{ discountPercentage }}% {{ selectedProductData?.content?.[lang]?.saving }})
              </span>
              }
            </div>
            <div class="ion-btn">
              <ion-button size="small" expand="block" color="secondary" class="join-btn-cash"
                [disabled]="!isNavigationAllowed" (click)="
                        creditInsufficient && creditValueTogg
                          ? callTopup()
                          : creditValueTogg
                            ? onCreditPayment()
                            : onJoinSyndicate()
                      ">
                @if ((!spinnerAnimation && proceed) || runSpinner()) {
                <span>{{ selectedProductData?.content?.[lang]?.join }}</span>
                }
                @if (spinnerAnimation && !runSpinner()) {
                <div class="spinners">
                  <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
                  </mat-progress-spinner>
                  <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
                  </mat-progress-spinner>
                </div>
                }
                @if (!proceed) {
                <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
                }
              </ion-button>
            </div>
            @if (showFlashSale) {
            <div class="flash-sale-text">{{ "store-product.discount_text" | translate }}</div>
            }
            @if (manageTrigger$.value) {
            <div class="dev_hide">
              <h1 class="ion-text-center jackpot-trigger" (click)="manageJackpotTrigger()">
                {{ "store-product.Manage Triggers" | translate }}
              </h1>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }
  <ng-template #loader>
    <app-in-progress-animation></app-in-progress-animation>
  </ng-template>
</ion-content>
}
@if (paymentDetails$ | async) {}